export default __webpack_public_path__ + "static/media/skype.302b26ed.svg";